import { Container } from 'react-bootstrap';
import { Link as ScrollTo } from 'react-scroll';
import { FaCheckCircle } from 'react-icons/fa';

const aboutHighlights = [
	{ value: '27+', label: 'Trade lanes navigated' },
	{ value: '98%', label: 'On-time performance' },
	{ value: '24/7', label: 'Client support coverage' },
	{ value: '300+', label: 'Strategic carrier alliances' },
];

const differentiators = [
	'Dedicated route engineers design optimal journeys for every shipment profile.',
	'Real-time milestone tracking keeps your team informed at every port call.',
	'Priority berthing, equipment allocation, and customs orchestration reduce dwell time.',
];

const DetailSection = () => {
	return (
		<Container className='mt-12 lg:mt-16'>
			<section className='relative overflow-hidden px-0 py-12 text-ttertiary md:px-14 md:py-16'>
				<div
					className='pointer-events-none absolute inset-0'
					aria-hidden='true'
				/>
				<div className='relative flex flex-col gap-10 notMobile:grid notMobile:grid-cols-[1.15fr_0.85fr] notMobile:items-center notMobile:gap-14'>
					<div className='flex flex-col justify-center gap-6'>
						<span className='inline-flex items-center self-start rounded-full border border-tprimary/30 bg-tprimary/5 px-4 py-1 text-xs font-semibold uppercase tracking-[0.35em] text-tprimary'>
							Our story
						</span>
						<h2 className='text-3xl font-semibold leading-tight text-ttertiary sm:text-4xl lg:text-[40px]'>
							Interlink Oceana keeps global supply chains confidently afloat
						</h2>
						<div className='space-y-4 text-balance'>
							<p className='text-base leading-relaxed text-gray-500 sm:text-lg'>
								Headquartered in Hong Kong with strong corridors across China,
								Dubai, and beyond, we orchestrate dependable ocean
								transportation that safeguards every container you entrust to
								us.
							</p>
							<p className='text-base leading-relaxed text-gray-500 sm:text-lg'>
								Our teams cultivate long-term partnerships with carriers and
								port authorities, securing priority berths, compliant
								documentation, and competitive pricing without compromising
								care.
							</p>
						</div>
						<ul className='mt-8 space-y-4 text-left'>
							{differentiators.map((point) => (
								<li
									key={point}
									className='flex items-start gap-4 text-base leading-relaxed text-ttertiary sm:text-lg'
								>
									<FaCheckCircle className='mt-1 flex-shrink-0 text-snooker text-lg' />
									<span>{point}</span>
								</li>
							))}
						</ul>
					</div>
					<div className='space-y-6 lg:justify-self-end'>
						<div className='grid grid-cols-2 gap-4 sm:grid-cols-2 sm:gap-5'>
							{aboutHighlights.map(({ value, label }) => (
								<div
									key={label}
									className='rounded-2xl border border-tprimary/20 bg-gradient-to-t from-red-100 via-slate-100 to-slate-200 px-6 py-7 text-center shadow-sm backdrop-blur transition hover:border-tprimary/40 hover:bg-white'
								>
									<span className='text-3xl font-semibold text-ttertiary sm:text-4xl'>
										{value}
									</span>
									<p className='mt-2 text-[12px] uppercase tracking-[0.3em] text-tgray sm:text-xs'>
										{label}
									</p>
								</div>
							))}
						</div>
					</div>
					<ScrollTo
						to='contact'
						smooth
						duration={600}
						offset={-80}
						className='mt-6 inline-flex w-full cursor-pointer items-center justify-center gap-3 rounded-full bg-tprimary px-6 py-3 text-base font-semibold text-tsecondary shadow-[0_18px_36px_-18px_rgba(189,53,49,0.8)] transition hover:bg-[#a6322f] focus:outline-none focus:ring-2 focus:ring-tprimary/50 sm:w-auto'
					>
						Partner with our experts
					</ScrollTo>
				</div>
			</section>
		</Container>
	);
};

export default DetailSection;
